/**
 * « Quitter l'exercice ? » — affiché quand l'élève appuie sur « retour »
 * pendant un exercice en cours (cf. `use-exit-guard.ts`).
 */

import { Button } from '@jeraisonne/ui';
import { Sheet } from '@/features/evaluations/sheet';

export function ExitConfirmSheet({ onStay, onLeave }: { onStay: () => void; onLeave: () => void }) {
  return (
    <Sheet
      title="Quitter l’exercice ?"
      onClose={onStay}
      footer={
        <div className="flex flex-col gap-2">
          <Button fullWidth onClick={onStay}>
            Continuer l’exercice
          </Button>
          <Button fullWidth variant="secondary" onClick={onLeave}>
            Quitter
          </Button>
        </div>
      }
    >
      <p className="text-ink-700 text-sm">
        Tes réponses sont gardées : tu pourras reprendre là où tu t’es arrêté.
      </p>
    </Sheet>
  );
}
